import React from 'react';
import Footer from '../Components/Footer';
import Header from '../Components/Header';
import JoinUs from '../Components/Joinus';
import MissionVision from '../Components/MissionVision';
import SocialMedia from '../Components/SocialMedia';
import LocalVideoPlayer from '../Components/LocalVideoplayer';
import ESS from '../Videos/ESS.mp4';

export default function Home() {
    return (
        <div>
            <Header />
            <div className='space-y-24'>
            <JoinUs />
            <div className='px-5 md:px-40'>
            <LocalVideoPlayer
            video={ESS}
            />
            </div>
            <div className='bg-[#F4DC7C] h-1 w-full m-auto my-4'></div>
            <MissionVision />
            <div className='bg-[#F4DC7C] h-1 w-full m-auto my-4'></div>
            <SocialMedia />
            <Footer />
            </div>
        </div>
    );
}